// extracted by mini-css-extract-plugin
export default {"container":"ZxM2m","no_border_radius":"FLBoJ","big":"m_7p6","plain":"isxe7"};